import { render, staticRenderFns } from "./Backdrop.vue?vue&type=template&id=752bf2fa&scoped=true&"
import script from "./Backdrop.vue?vue&type=script&lang=js&"
export * from "./Backdrop.vue?vue&type=script&lang=js&"
import style0 from "./Backdrop.vue?vue&type=style&index=0&id=752bf2fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752bf2fa",
  null
  
)

export default component.exports